import React from 'react';

const TwoFactorSection = () => (
  <div className="flex items-center">
    <input
      type="checkbox"
      id="2faEnabled"
      name="2faEnabled"
      className="rounded border-gray-300 text-primary focus:ring-primary"
    />
    <label htmlFor="2faEnabled" className="ml-2 block text-sm text-white">
      Enable Two Factor Authentication
    </label>
  </div>
);

export default TwoFactorSection;
